import React from 'react'
import httpClient from './myapi'
import LazyLoad from 'react-lazyload'
import './styles/gallery.css'
import MyLightBox from './MyLightBox';
import ImageCard from './ImageCard'
import store from './redux/store';
import { bkupImages } from './redux/actions/index'
import FilterImage from './FilterImage'
import {
    Container, Row, Col, InputGroupAddon, InputGroupText, InputGroup,
    Input, Button, FormText
} from 'reactstrap';
import Icon from './styles/icon';



export default class Gallery extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            bkupImages: [],
            allCols: [],
            allImgs: [],
            // loaded: [],
            showLightBox: false,
            photoIndex: 0,
            searchInp: '',
            searchFired: false
        }
        this.urlCat = this.props.match.params.cat;

    }
    componentDidMount() {
        const storeImgs = store.getState().allImgs;
        if (storeImgs.length > 0) {//IMAGES ALREADY DOWNLOADED

            this.divideImgs(storeImgs, store.getState().cart)
        } else { //NOT DOWNLOADED YET
            httpClient.get('/getImages.php').then((res) => {
                if (res.length) {
                    this.setState({ bkupImages: res })
                    this.divideImgs(res, []);
                } else {
                    alert("No Internet")
                }
            })
        }
    }
    divideImgs(res, cart) {
        const col1 = [], col2 = [], col3 = [], col4 = [], allCols = []

        //CHECK IF IMAGE SELECTED IN CART
        if (cart.length) {
            res.forEach((sari) => {
                sari.selected = false;
                cart.forEach((selSari) => {
                    if (sari.id === selSari) {
                        sari.selected = true
                    }
                });
            });
        }

        //DIVIDE IMAGES IN 4 COLUMNS
        const max = parseInt(res.length, 10) / 4
        for (let j = 0, i = 0; j < max; j++ , i += 4) {
            col1.push(res[i])

            if (res[i + 1] !== void 0) {//CHECK IF KEY EXIST
                col2.push(res[i + 1])
            }
            if (res[i + 2] !== void 0) {
                col3.push(res[i + 2])
            }
            if (res[i + 3] !== void 0) {
                col4.push(res[i + 3])
            }
        }

        allCols.push(col1)
        allCols.push(col2)
        allCols.push(col3)
        allCols.push(col4)

        this.setState({
            allCols: allCols,
            // loaded: arr,
            allImgs: res //for lightbox
        })

        //
        store.dispatch(bkupImages(res));

    }
    openLightbox = (imgId) => {
        const arr = this.state.allImgs.slice()
        const max = arr.length
        let index = -1;
        for (let i = 0; i < max; i++) {
            if (arr[i].id === imgId) {
                index = i;
                break;
            }
        }
        this.setState({
            photoIndex: index,
            showLightBox: true
        })
    }
    closeLightBox = () => {
        this.setState({
            showLightBox: false
        })
    }
    sortImages = (cat) => {
        const bkup = this.state.bkupImages;
        if (cat === "0") {
            this.divideImgs(bkup, store.getState().cart);
        } else {

            const arr = [];
            bkup.forEach(sari => {
                if (sari.cat === cat) {
                    arr.push(sari)
                }
            });
            this.divideImgs(arr, store.getState().cart);
        }
    }
    searchImage = () => {
        //TO SHOW CLEAR BUTTON
        const query = this.state.searchInp;

        //CHECK IF QUERY IS A NUMBER
        if (isNaN(parseInt(query, 10))) {
            return;
        }

        const imgs = this.state.bkupImages;
        const max = imgs.length;
        const found = [];
        for (let i = 0; i < max; i++) {
            if (imgs[i].id === this.state.searchInp) {
                found.push(imgs[i]);
            }
        }

        if (found.length) {
            this.setState({
                allImgs: found,
                allCols: [found],
                searchFired: true
            });
        } else {
            this.setState({
                notFound: true
            });
        }
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            notFound: false
        });
    }
    clearSearch = () => {
        this.setState({
            searchFired: false,
            searchInp: ''
        });
        this.divideImgs(this.state.bkupImages, store.getState().cart)
    }
    render() {
        const { showLightBox, allImgs, photoIndex } = this.state

        return (
            <div className="blank-page">
                <div className="pageheading2">
                    <h1>Gallery</h1>
                </div>
                <Container>
                    <Row>
                        <Col>
                            <InputGroup size="sm">
                                <InputGroupAddon addonType="prepend">
                                    #
                                </InputGroupAddon>
                                <Input
                                    type="number"
                                    value={this.state.searchInp}
                                    onChange={this.handleChange('searchInp')}
                                    placeholder="Product Id" />
                                <InputGroupAddon addonType="append">
                                    {!this.state.searchFired &&
                                        <Button onClick={this.searchImage}
                                            className="theme-button">
                                            <Icon icon="fa-search" />
                                        </Button>
                                    }
                                    {this.state.searchFired &&
                                        <Button onClick={this.clearSearch}
                                            color="danger">
                                            <Icon icon="fa-times" />
                                            {' '}Clear</Button>
                                    }

                                </InputGroupAddon>
                            </InputGroup>
                            {
                                this.state.notFound &&
                                <FormText color="danger">
                                    No Result !
                                </FormText>
                            }
                        </Col>
                        <Col>
                            <InputGroup size="sm">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <Icon icon="fa-filter" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <FilterImage onselect={this.sortImages} />
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
                {showLightBox &&
                    <MyLightBox allImgs={allImgs} photoIndex={photoIndex} closeHandler={this.closeLightBox} />
                }

                <div className="gallery-row">
                    {
                        this.state.allCols.map((col, j) => (
                            <div key={j} className="gallery-col">
                                {
                                    col.map((img, ind) => (
                                        <LazyLoad key={ind} height={80} once offset={100}>
                                            <ImageCard key={ind}
                                                img={img}
                                                onclick={() => this.openLightbox(img.id)}
                                                isAdmin={false}
                                                secondAction={() => this.addToCart(img.id)}
                                            />
                                        </LazyLoad>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Gallery.jsx